var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"text-center icon-class"},[_vm._t("icon"),_c('div',[_vm._v(_vm._s(_vm.name))])],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }